import bucmAxios from './bucm-axios';

export const getBucmUser = (data?: BUCM.GetUserRequest) =>
    bucmAxios<BUCM.UserResponseWrapped>({
        url: '/users/get',
        data: data || {}
    });
